var render, staticRenderFns
import script from "./Splines.vue?vue&type=script&lang=js&"
export * from "./Splines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d0f874')) {
      api.createRecord('63d0f874', component.options)
    } else {
      api.reload('63d0f874', component.options)
    }
    
  }
}
component.options.__file = "src/components/overlays/Splines.vue"
export default component.exports